import { Link, useParams } from 'react-router-dom';
import { InterviewSession } from './InterviewSession';
import type { UseVapiReturn } from '../hooks/useVapi';

interface SessionPageProps {
  vapi: UseVapiReturn;
  onCallIdChange?: (callId: string | null) => void;
}

export function SessionPage({ vapi, onCallIdChange }: SessionPageProps) {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return (
      <main className="min-h-screen bg-background text-foreground">
        <section className="flex w-full flex-col gap-6 px-6 py-12 lg:px-12 xl:px-16">
          <h1 className="text-3xl font-bold">Interview Session</h1>
          <p className="rounded-xl border border-kaiva-coral/30 bg-kaiva-coral/10 p-4 text-sm text-kaiva-coral">
            Session ID is missing from the route.
          </p>
          <Link
            to="/"
            className="inline-flex w-fit rounded-full border border-kaiva-teal/40 bg-card px-4 py-2 text-xs font-semibold text-kaiva-teal transition hover:bg-kaiva-teal/10"
          >
            Back Home
          </Link>
        </section>
      </main>
    );
  }

  return (
    <main className="min-h-screen bg-background text-foreground">
      <InterviewSession sessionId={id} vapi={vapi} onCallIdChange={onCallIdChange} />
    </main>
  );
}
